import React from 'react';
import { Button } from 'antd'
import './AccountNoData.css'

const AccountNoData = ({ mode = 'personal', connectAccount }) => {
  return (
    <div className="credit-report-setup">
        <div className="no-account-content">
            <img src='/images/no-account.svg' />
            <div>
                <div className="no-account-title">No account connected yet</div>
                <div className="no-account-description">{mode === 'personal' ? 'Connect a credit account to enable faster, easier credit checks with Zeitro.' : 'Connect a credit account to enable faster, easier credit checks for all team members with Zeitro.'}</div>
            </div>
            <Button className="connect-account-btn" onClick={() => { connectAccount() }}>Connect new account</Button>
        </div>
    </div>
  )
}

export default AccountNoData